import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyDc0QyXbmxNPBNF9gLljEoUzGuz5RapU0o",
  authDomain: "pss-asmm.firebaseapp.com",
  projectId: "pss-asmm",
  storageBucket: "pss-asmm.firebasestorage.app",
  messagingSenderId: "496233279832",
  appId: "1:496233279832:web:c8297d368ea0d0d707352d",
  measurementId: "G-3J8G4MFWK0"
};

// Initialize Firebase App as Singleton
export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Initialize Analytics conditionally for browser environment
export let analytics: any = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  }).catch(() => { });
}

/**
 * Triggers Google Sign-In pop-up.
 */
export async function signInWithGooglePopup() {
  return signInWithPopup(auth, googleProvider);
}

/**
 * Signs out of Firebase Auth.
 */
export async function signOutFirebase() {
  return signOut(auth);
}
